import { defineMessages } from 'react-intl';

export default defineMessages({
    vendorsInvolved: {
        id: 'claim.views.claim-detail.claim.views.claim-detail.Vendors involved',
        defaultMessage: 'Vendors involved'
    },
    AdjusterMessage: {
        id: "claim.views.claim-detail.AdjusterMessage",
        defaultMessage: "Call us or send a message to your adjuster"
    },
    LossDescription: {
        id: "claim.views.claim-detail.Loss Description",
        defaultMessage: "Loss Description"
    },
    ContactPerson: {
        id: "claim.views.claim-detail.Contact Person",
        defaultMessage: "Contact Person"
    },
    PrimaryEmail: {
        id: "claim.views.claim-detail.Primary Email",
        defaultMessage: "Primary Email"
    },
    PrimaryPhone: {
        id: "claim.views.claim-detail.Primary Phone",
        defaultMessage: "Primary Phone"
    },
    LossItems: {
        id: "claim.views.claim-detail.Loss Items",
        defaultMessage: "Loss Items"
    },
    ClaimStatus: {
        id: "claim.views.claim-detail.claimStatus",
        defaultMessage: "Claim Status"
    },
    ClaimNoteMessage: {
        id: "claim.views.claim-detail.For any further questions",
        defaultMessage: "For any questions regarding your claim, please contact your adjuster."
    },
    ClaimEFTHeading: {
        id: "claim.views.claim-detail.Claims EFT Heading",
        defaultMessage: "Receive Payments by Electronic Funds Transfer Direct Deposit"
    },
    claimEFTPaymentSuccess: {
        id: 'claim.views.claim-detail.Payment Method successfully added.',
        defaultMessage: 'Payment Method successfully added.'
    },
    paymentStatus: {
        id: 'claim.views.claim-detail.Payment Status',
        defaultMessage: 'Payment Status'
    },
    brokerPaymentNoteMsg: {
        id: 'claim.views.claim-detail.To change method of payment please contact your Broker/Agent',
        defaultMessage: 'To change method of payment please contact your Broker/Agent'
    },

});
